import { Button, Dialog, DialogActions, DialogTitle } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';
import { useDeleteTransferMutation } from '../../../api/transfers';
import { ApiPayoutTransfer } from '../../../openapi';

export function DeleteTransferDialog({
  transfer,
  onClose,
}: {
  transfer?: ApiPayoutTransfer | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const mutation = useDeleteTransferMutation();

  const handleDeleteTransfer = useCallback(() => {
    if (transfer) {
      mutation.mutate({
        transferId: transfer.id,
        createdAt: transfer.createdAt,
        type: transfer.type === 'Internal' ? 'internal' : 'external',
      });
    }
  }, [mutation, transfer]);

  useEffect(() => {
    if (mutation.isSuccess) {
      onClose();
      mutation.reset();
    }
  }, [mutation, onClose]);

  return (
    <Dialog open={Boolean(transfer)} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>{t('Are you sure you want to delete this transfer?')}</DialogTitle>
      <DialogActions>
        <Button autoFocus color="secondary" onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button color="error" loading={mutation.isPending} onClick={handleDeleteTransfer}>
          {t('Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
